// consts/enums
export const DARWIN_APPLICATION_NAME = 'DarwinFI';
export const DARWIN_SPONSOR = 'Darwin';
export const DARWIN_CLIENT_NAME = 'Darwin';

/**
 * Detects whether a WebSocket deal event originated from Darwin.
 *
 * Darwin patches the deal via the Deal API PATCH dealStructure endpoint. When a new deal
 * version is created, Deal API rewrites `versionCreatedBy.applicationName` to
 * `CAI-Deal-Change-Processor-Service`, so a single applicationName check is insufficient.
 * We therefore OR four signals; any one being a Darwin marker is enough.
 */
export const isDealVersionFromDarwin = (event: any): boolean => {
    const versionCreatedBy = event?.data?.dealStructure?.versionCreatedBy;
    return (
        versionCreatedBy?.applicationName === DARWIN_APPLICATION_NAME ||
        versionCreatedBy?.sponsor === DARWIN_SPONSOR ||
        versionCreatedBy?.applicationName === DARWIN_CLIENT_NAME ||
        event?.data?.meta?.clientName === DARWIN_CLIENT_NAME
    );
};
